/**
 * Checks if there's at least one successful Fannie or Freddie inspection submission
 * @param {Array} inspectionSubmissionsData - Array of inspection submission objects
 * @returns {boolean} - True if at least one successful Fannie or Freddie submission exists
 */
export const hasSuccessfulGseSubmission = (inspectionSubmissionsData) => {
  if (!inspectionSubmissionsData || !Array.isArray(inspectionSubmissionsData)) {
    return false
  }

  return inspectionSubmissionsData.some(
    (submission) => (submission.type === 'fannie' || submission.type === 'freddie') && submission.status === 'complete',
  )
}
